/**
 * Booster populateSearchSuggest() injects products, articles, and pages
 * into [data-search-suggest] (the products grid). Move articles/pages into
 * [data-search-aside] so layout CSS can place them on the right.
 */
(function () {
  'use strict';

  var SECTION_LABELS = { articles: true, pages: true };

  function isLinkSectionBlock(el) {
    if (!el || el.nodeType !== 1) return false;
    var h4 = el.querySelector('h4');
    if (!h4) return false;
    var label = (h4.textContent || '').trim().toLowerCase();
    return SECTION_LABELS[label] === true;
  }

  function normalizeSection(block) {
    block.classList.add('search__results__section');

    var title = block.querySelector('h4');
    if (title) {
      title.classList.add('search__results__section-title', 'body-small', 'font-weight-bold');
      title.classList.remove('col-12');
      title.style.marginTop = '';
    }

    block.querySelectorAll('a').forEach(function (link) {
      link.classList.remove('col-12');
      link.classList.add('search__results__link', 'body-small');
    });
  }

  function syncEmptyProductGrid(container) {
    var suggest = container.querySelector('[data-search-suggest]');
    if (!suggest) return;

    var input = container.querySelector('input[data-search], input[name="q"][type="search"]');
    var isEmpty = !input || !String(input.value || '').trim();
    suggest.classList.toggle('search__results__products--empty', isEmpty);
  }

  function splitSearchResultsInContainer(container) {
    var suggest = container.querySelector('[data-search-suggest]');
    var aside = container.querySelector('[data-search-aside]');
    if (!suggest || !aside) return;

    syncEmptyProductGrid(container);

    aside.innerHTML = '';

    var toMove = [];
    Array.from(suggest.children).forEach(function (child) {
      if (isLinkSectionBlock(child)) {
        toMove.push(child);
      }
    });

    toMove.forEach(function (block) {
      normalizeSection(block);
      aside.appendChild(block);
    });

    if (aside.children.length > 0) {
      aside.removeAttribute('hidden');
    } else {
      aside.setAttribute('hidden', '');
    }
  }

  function featuredImageUrl(product) {
    if (!product) return '';
    var fi = product.featured_image || product.image;
    if (!fi) return '';
    if (typeof fi === 'string') return fi;
    return fi.url || fi.src || '';
  }

  function patchRenderProductCard() {
    var bt = window.BoosterTheme;
    if (!bt || !bt.ELEMENTS || bt.ELEMENTS.__searchImagePatched) return;

    var original = bt.ELEMENTS.renderProductCard;
    if (typeof original !== 'function') return;

    bt.ELEMENTS.renderProductCard = function (product) {
      var card = original.call(this, product);
      var img = card && card.querySelector('[data-product-image]');
      var url = featuredImageUrl(product);
      if (img && url) {
        img.src = url;
        img.alt = product.title || '';
        img.removeAttribute('width');
        img.removeAttribute('height');
      }
      return card;
    };

    bt.ELEMENTS.__searchImagePatched = true;
  }

  function splitAll() {
    document.querySelectorAll('[data-search-container]').forEach(splitSearchResultsInContainer);
  }

  function bindSearchInputs() {
    document.querySelectorAll('[data-search-container]').forEach(function (container) {
      var input = container.querySelector('input[data-search], input[name="q"][type="search"]');
      if (!input || input.__searchLayoutSplitBound) return;
      input.__searchLayoutSplitBound = true;
      input.addEventListener('input', function () {
        syncEmptyProductGrid(container);
      });
    });
  }

  document.addEventListener('booster:content:update', splitAll);
  document.addEventListener('booster:loaded', patchRenderProductCard);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchRenderProductCard();
      splitAll();
      bindSearchInputs();
    });
  } else {
    patchRenderProductCard();
    splitAll();
    bindSearchInputs();
  }

  document.addEventListener('shopify:section:load', function () {
    patchRenderProductCard();
    splitAll();
    bindSearchInputs();
  });
})();
